import EnableLocationPop from "./EnableLocationPop";

export default EnableLocationPop;
